import { init, priceDecorator, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"
import { getWizardConfig } from "./wizard"

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    hitDecorators: [
        priceDecorator(),
        thumbnailDecorator({ size: "9" })
    ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.size": "pageSize",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    // serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "imageHash",
                "thumbUrl",
                "description",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "priceCurrencyCode",
                "ratingValue",
                "reviewCount"
                // 'customFields.key', 'customFields.value'
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    compressUrlParameters: true,
    fallback: true,
    categoryCssSelector: '#nosto-category-page',
    categoryQuery: {
        products: {
            categoryId: document.getElementById('nosto-category-page').getAttribute('data-category-id'),
            size: defaultConfig.serpSize,
            from: 0
        }
    }
})